import { render, staticRenderFns } from "./patology_anatomy.vue?vue&type=template&id=5632d71b&scoped=true&"
import script from "./patology_anatomy.vue?vue&type=script&lang=js&"
export * from "./patology_anatomy.vue?vue&type=script&lang=js&"
import style0 from "./patology_anatomy.vue?vue&type=style&index=0&id=5632d71b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5632d71b",
  null
  
)

export default component.exports